var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { ActionTabs } from './ActionTabs';
import { CareerTrackRadio } from './CareerTrackRadio';
import { appStrings } from '../assets/appStrings';
import { TRACK_CODE_TO_NAME, TIER_TO_CAREER_TRACK_NAME } from '../models/careerPath';
var STRINGS = appStrings.buttonText;
var ACTION_TAB_STRINGS = appStrings.modules.actionTabs;
export var CareerTrackCard = function (_a) {
    var code = _a.code, subtitle = _a.subtitle, description = _a.description, onBookmark = _a.onBookmark, onShare = _a.onShare, onAddTask = _a.onAddTask, hasBookmarked = _a.hasBookmarked, _b = _a.hideActions, hideActions = _b === void 0 ? false : _b;
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    var actions = useMemo(function () {
        var a = [];
        if (onBookmark)
            a.push({
                icon: hasBookmarked ? 'BookmarkCheck' : 'Bookmark',
                onClick: onBookmark,
                tooltipHoverText: ACTION_TAB_STRINGS.bookmark,
            });
        if (onShare)
            a.push({
                icon: 'Share06',
                onClick: onShare,
                tooltipHoverText: ACTION_TAB_STRINGS.share,
            });
        if (onAddTask)
            a.push({
                icon: 'ClipboardPlus',
                onClick: onAddTask,
                tooltipHoverText: ACTION_TAB_STRINGS.task,
            });
        return a;
    }, [onBookmark, hasBookmarked, onShare, onAddTask]);
    var careerTrack = TRACK_CODE_TO_NAME[code];
    var careerTrackName = TIER_TO_CAREER_TRACK_NAME[careerTrack];
    return (_jsxs(Box, { sx: cardContainerSx(hideActions), children: [_jsxs(Box, { sx: headercontainerSx, children: [_jsx(CareerTrackRadio, { careerTrack: careerTrackName, width: 30 }), !hideActions && (_jsx(ActionTabs, { actions: actions, borderColor: "Colors/Border/border-primary" }))] }), _jsxs(Box, { sx: contentContainerSx, children: [_jsxs(Box, { sx: textContainerSx, children: [_jsx(Typography, { variant: "text-sm-medium", sx: { color: function (_a) {
                                        var backrs = _a.backrs;
                                        return backrs.colors['Colors/Text/text-tertiary'];
                                    } }, children: subtitle }), _jsx(Typography, { variant: "display-xs-semibold", sx: trackNameSx, children: careerTrack }), _jsx(Collapse, { in: expanded, collapsedSize: 0, timeout: 250, children: _jsx(Typography, { id: careerTrack, variant: "text-sm-regular", sx: {
                                        color: function (_a) {
                                            var backrs = _a.backrs;
                                            return backrs.colors['Colors/Text/text-tertiary'];
                                        },
                                        mt: function (_a) {
                                            var backrs = _a.backrs;
                                            return backrs.spacing['spacing-sm'];
                                        },
                                    }, children: _jsx(ReactMarkdown, { children: description }) }) })] }), _jsx(Typography, { component: "span", variant: "text-sm-semibold", color: function (t) { return t.backrs.colors['Colors/Foreground/fg-brand-primary']; }, onClick: function () { return setExpanded(function (prev) { return !prev; }); }, sx: readMoreBtnBaseSx, children: expanded ? STRINGS.readLess : STRINGS.readMore })] })] }));
};
var cardContainerSx = function (hideBeforeBorder) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            backgroundColor: backrs.colors['Colors/Background/bg-primary'],
            borderRadius: backrs.radius['radius-xl'],
            padding: backrs.spacing['spacing-xl'],
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            boxSizing: 'border-box',
            border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quinary-hover']),
            boxShadow: backrs.shadows['shadow-xs'],
            width: '100%',
            '&::before': __assign({ content: '""', position: 'absolute', inset: 0, borderRadius: backrs.radius['radius-xl'], pointerEvents: 'none' }, (!hideBeforeBorder && {
                border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quinary']),
            })),
        });
    };
};
var headercontainerSx = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start',
};
var contentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-sm'],
        width: '100%',
    });
};
var textContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xs'],
        width: '100%',
    });
};
var readMoreBtnBaseSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        alignSelf: 'flex-end',
        mt: backrs.spacing['spacing-sm'],
        cursor: 'pointer',
    });
};
var trackNameSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        mt: backrs.spacing['spacing-xs'],
    });
};
